import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import { i18n } from "base/i18n";
import { Button, BUTTON_TYPES, BUTTON_SIZES } from "widgets/inputs";
import { useAccountStore } from "base/stores";
import { KfIllustration, KF_ILLUSTRATIONS } from "widgets/kficon";

import { Wrapper } from "../wrapper/index.jsx";
import { ACCOUNT_STATUS } from "@account/common/helpers/constants/login.constant.js";
import {
  LoginService,
  helperMethods,
  initializeErrorDetails
} from "@account/common/helpers/index.js";

import styles from "./style.css";

const LockUserLifeCycleIcon = () => (
  <KfIllustration icon={KF_ILLUSTRATIONS.LOCKED} />
);

export const AccountStatusUI = (props) => {
  const {
    title,
    description,
    type,
    statusIcon,
    button,
    args,
    service = LoginService
  } = props;
  const [details, setDetails] = useState({
    title,
    description,
    type,
    statusIcon,
    button
  });
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  let methods = {
    RequestAccess: async () => {
      try {
        let [result] = service.requestAccess({
          userId: args.UserId
        });
        await result();
        let { Name } = useAccountStore.getState();
        return {
          error: {
            error_code: "KISSFLOW_ERROR_00027",
            args: { account_name: Name }
          }
        };
      } catch (error) {
        throw error;
      }
    }
  };

  let handlActions = { ...helperMethods, ...methods };

  async function onStatusBtnClick() {
    try {
      let methodToCall = handlActions[details.button.key];
      if (methodToCall) {
        setIsLoading(true);
        let response = await methodToCall(history);
        if (response) {
          let error = initializeErrorDetails(response);
          setDetails({
            title: error.title,

            description: (
              <p className="base">
                {typeof error.description === "function"
                  ? error.description({
                      errorCode: response.error.error_code,
                      args: error.args
                    })
                  : i18n._(error.description)}
              </p>
            ),
            type: error.type,
            statusIcon: <error.webImg />,
            button: error.button,
            args: error.args
          });
        }
      }
    } catch (error) {
      console.info("Error on account status", error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Wrapper className={styles.accountStatusWrapper} showBGImage={false}>
      <Wrapper.Body
        className={`${styles.accountStatusChildContainer} ${
          details.type === ACCOUNT_STATUS.WARNING ? styles.warning : ""
        }`}
      >
        {details.statusIcon}
        <Wrapper.Title className={styles.statusTitle}>
          {details.title}
        </Wrapper.Title>
        <div className={styles.statusDescription}>{details.description}</div>
        {details.button && (
          <Button
            type={BUTTON_TYPES.PRIMARY}
            size={BUTTON_SIZES.LARGE}
            onClick={onStatusBtnClick}
            isLoading={isLoading}
          >
            {i18n._(details.button.value)}
          </Button>
        )}
      </Wrapper.Body>
    </Wrapper>
  );
};

AccountStatusUI.propTypes = {
  title: PropTypes.string,
  description: PropTypes.node,
  type: PropTypes.string,
  statusIcon: PropTypes.node,
  button: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string
  }),
  args: PropTypes.shape({
    UserId: PropTypes.string
  }),
  service: PropTypes.shape({
    requestAccess: PropTypes.func
  })
};

AccountStatusUI.defaultProps = {
  statusIcon: <LockUserLifeCycleIcon />
};
